var styles = {"box":"VipLink_box_106ep_1","text":"VipLink_text_106ep_22","empty":"VipLink_empty_106ep_25","add-node":"VipLink_add-node_106ep_28","mask-1":"VipLink_mask-1_106ep_31","mask-2":"VipLink_mask-2_106ep_31","icon-container":"VipLink_icon-container_106ep_53"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
